import { render, staticRenderFns } from "./riderwiseofd.vue?vue&type=template&id=4835eb32"
import script from "./riderwiseofd.vue?vue&type=script&lang=js"
export * from "./riderwiseofd.vue?vue&type=script&lang=js"
import style0 from "./riderwiseofd.vue?vue&type=style&index=0&id=4835eb32&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports